var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"helper-info"},[_c('div',{staticClass:"menu_drop"},[_c('div',{staticClass:"dropdown"},[_vm._t("description")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }